import React from 'react'
import PropTypes from 'prop-types'
import { useFilterValue, useWillConstrain } from '@morningtrain/react-filters'
import DatePicker, { registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'
import ReactDOM from 'react-dom'
import PopperElement from 'services/PopperElement'
import { FieldWrapper } from '@morningtrain/react-fields'
import OnClickOutside from 'services/OnClickOutside'
import * as UI from 'ui'
import da from 'date-fns/locale/da'

registerLocale('da', da)

export default function DateFilter (props) {
  const referenceElementRef = React.useRef(null)

  const [value, setValue] = useFilterValue(props.name, props.defaultValue)

  const defaultValue = value ? moment(value).toDate() : null

  const [date, setDate] = React.useState(defaultValue)
  const [active, setActive] = React.useState(false)

  const shouldConstrainCheck = React.useCallback((val) => {
    return !!val
  }, [])

  useWillConstrain(props.name, value, shouldConstrainCheck)

  React.useEffect(() => {
    const nextDate = date !== null ? moment(date).format('YYYY-MM-DD') : null

    if (nextDate === null) {
      return
    }

    if (value === null || nextDate !== value) {
      setValue(nextDate)
      if (props.shouldCloseOnSelect === true) {
        setActive(false)
      }
    }
  }, [date])

  React.useEffect(() => {
    if (typeof props.onChange === 'function') {
      props.onChange(value)
    }
  }, [value])

  const clearPeriod = (e) => {
    setDate(null)
    e.stopPropagation()
  }

  const onChanged = (date) => {
    setDate(date)
  }

  return (
    <FieldWrapper label={props.label} className={props.className}>
      <div className='datepicker-container flex items-center'>
        <div ref={referenceElementRef} onClick={() => setActive(!active)} className='datepicker-selector'>
          {(date !== null) && props.clearable ? (
            <button className='pr-3' onClick={(e) => clearPeriod(e)}>
              <UI.Icons.Decline />
            </button>) : null}
          {date !== null ? moment(date).format('DD-MM-YYYY') : null}
          {props.children}
        </div>
        {!active ? null : ReactDOM.createPortal((
          <PopperElement referenceElementRef={referenceElementRef.current}>
            <OnClickOutside onClickOutside={() => setActive(false)}>
              <div className='flex space-x-6 p-4 bg-white shadow-xl border rounded'>
                <DatePicker
                  selected={date}
                  startDate={date}
                  onChange={(date) => {
                    onChanged(date)
                  }}
                  showWeekNumbers
                  formatWeekDay={nameOfDay => nameOfDay.substr(0, 3)}
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode='select'
                  locale='da'
                  inline
                />
              </div>
            </OnClickOutside>
          </PopperElement>
        ), document.body)}
      </div>
    </FieldWrapper>
  )
}

DateFilter.defaultProps = {
  defaultValue: null,
  clearable: false,
  shouldCloseOnSelect: true
}

DateFilter.propTypes = {
  name: PropTypes.string.isRequired,
  clearable: PropTypes.bool,
  shouldCloseOnSelect: PropTypes.bool
}
